import { Modal } from "@joonapp/web-shared"

import AddEditQuest from "./AddEditQuest"
import QuestDetails from "./QuestDetails"
import { QuestModalView, useQuestModalStore } from "./useQuestModalStore"

const QuestModal = () => {
  const { isOpen, onClose, view } = useQuestModalStore()

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      style={{ width: "min(600px, 100vw)", maxHeight: "100dvh" }}
      mandatory
    >
      {view === QuestModalView.ADD || view === QuestModalView.EDIT ? (
        <AddEditQuest />
      ) : (
        <QuestDetails />
      )}
    </Modal>
  )
}

export default QuestModal
